module.exports = __webpack_public_path__ + "img/mask-group.ca319b53.svg";